<template>
  <div class="vr360-app-header__left" :class="{'no-flex': state === 'publicList' || state === 'myList'}">
    
    <template 
      v-if="state !== 'myList' &&
            state !== 'publicList' &&
            state !== 'createStream' &&
            state !== 'profile' &&
            state !== 'editProfile' &&
            state !== 'show' &&
            state !== 'finish' &&
            state !== 'shared'"
    >
      <router-link 
        class="vr360-app-header__left__back"
        :to="linkToBack"
      >
        <svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M6 1L1 6L6 11" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
        </svg>
      </router-link>
    </template>

    <template 
      v-if="state === 'createStream' ||
            state === 'profile' ||
            state ==='editProfile'"
    >
      <button type="button"
        @click="$router.go(-1)"
        class="vr360-app-header__left__back"
      >
        <svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M6 1L1 6L6 11" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
        </svg>
      </button>
    </template>
    <template
      v-if="state === 'publicList'">
      <h1 class="vr360-head-h1 vr360-text-blue vr360-app-header__left__title">Feed</h1>
    </template>
    <template v-if="state === 'myList'">
      <div class="vr360-app-header__left__avatar">
        <p class="vr360-app-header__left__avatar__img">
          <img class="vr360-avatar-stub" :src="user.avatar | storagePath" alt="">
        </p>
        <p class="vr360-app-header__left__avatar__text">
          <span class="vr360-head-h2 vr360-text-blue vr360-text-elips">
            <template v-if="!user.name && !user.surname">
              {{user.email}}
            </template>
            <template v-else>
              {{user.name}} {{user.surname}}
            </template>
          </span>
          <!-- <span class="vr360-head-h1 vr360-text-blue">{{user.name}} {{user.surname}}</span> -->
          <span class="vr360-text-caption vr360-text-gray-2 vr360-text-elips">
            <template v-if="user.streams_count > 0">
              {{user.streams_count | streams}}
            </template>
            <template v-else>
              You havn`t streams
            </template>
          </span>
        </p>
      </div>
    </template>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "leftHeader",
  data() {
    return {
      state: null,
      linkToBack: null
    };
  },
  created() {
    this.checkToShow(this.$route.name);
  },
  methods: {
    checkToShow(name) {
      switch (name) {
        case "ListMyStreams":
          this.state = "myList";
          break;
        case "ListPublicStreams":
          this.state = "publicList";
          break;
        case "ItemMyStream":
          this.state = "myStream";
          this.linkToBack = {
            name: "ListMyStreams",
            query: {
              filter: this.filter || "all"
            }
          };
          break;
        case "ItemPublicStream":
          this.state = "publicStream";
          this.linkToBack = {
            name: "ListPublicStreams",
            query: {
              filter: this.filter || "all"
            }
          };
          break;
        case "EditStream":
          this.state = "editStream";
          this.linkToBack = {
            name: "ItemMyStream",
            params: { id: this.$route.params.id }
          };
          break;
        case "CreateStream":
          this.state = "createStream";
          this.linkToBack = {
            name: "ItemMyStream",
            params: { id: this.$route.params.id }
          };
          break;
        case "ShowStream":
          this.state = "show";
          break;
        case "ShowSharedStream":
          this.state = "shared";
          break;
        case "FinishStream":
          this.state = "finish";
          break;
        case "MenuProfile":
          this.state = "profile";
          break;
        case "EditProfile":
          this.state = "editProfile";
          break;
        default:
          this.state = null;
          break;
      }
    }
  },
  watch: {
    $route(to) {
      this.checkToShow(to.name);
    }
  },
  computed: {
    ...mapGetters({
      filter: "stream/streamsListFilter",
      currentStream: "stream/currentStream",
      user: "user/user"
    })
  }
};
</script>

<style lang="scss">
</style>
